<template>
  <div class="content">
    <div class="holder container">
      orderNo:
      <input type="text" v-model="order.orderNo" />
      <br />Front:
      <input type="text" v-model="order.thumbnailFrontURL" />
      <br />Back:
      <input type="text" v-model="order.thumbnailBackURL" />
      <br />
      <button @click="gotoNext()">go to b025</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "A020",
  data() {
    return {
      order: {
        orderNo: "2020081101000232",
        thumbnailFrontURL:
          "https://content-test.photosmile.biz/test_test/%E5%AE%8C%E5%85%A8%E3%83%87%E3%83%BC%E3%82%BF_%E8%A1%A8.jpg",
        thumbnailBackURL:
          "https://content-test.photosmile.biz/test_test/%E5%AE%8C%E5%85%A8%E3%83%87%E3%83%BC%E3%82%BF_%E8%A3%8F.jpg"
      }
    };
  },
  methods: {
    gotoNext() {
      //todo
      // fake data for dev
      this.$store.commit("userData/SET_ORDER", this.order);
      this.$router.push({ name: "a025" });
    }
  }
};
</script>
